import { takeLatest, put, call } from 'redux-saga/effects';

import { uploadOfx } from '../../service';

import {
  HIDE_MODAL_OFX_CONFIRMACAO,
  UPLOAD_EXTRATOS_OFX_FAILURE,
  UPLOAD_EXTRATOS_OFX_PENDING,
  UPLOAD_EXTRATOS_OFX_SUCCESS,
  UPLOAD_EXTRATOS_OFX,
} from '@handler';

import { AlertSuccess, AlertError } from '@components/common/AlertToast';

function* sagaUploadExtratoOfx(action) {
  yield put({ type: UPLOAD_EXTRATOS_OFX_PENDING });

  try {
    const formData = new FormData();
    formData.append('arquivo', action.data.arquivoOfx);
    formData.append('contaBancoId', action.data.contaBanco.id);
    // formData.append('saldoFinal', action.data.saldoFinal);

    const resp = yield call(uploadOfx, formData);

    yield put({
      type: UPLOAD_EXTRATOS_OFX_SUCCESS,
      response: resp.data,
    });
    yield put({ type: HIDE_MODAL_OFX_CONFIRMACAO });

    AlertSuccess('Arquivo OFX importado com sucesso!');
  } catch (error) {
    yield put({ type: UPLOAD_EXTRATOS_OFX_FAILURE });

    if (error.response && error.response.status === 422) {
      AlertError(
        error.response.data.text ||
          'Erro na validação dos dados do arquivo OFX',
      );
    } else {
      AlertError('Falha ao importar arquivo OFX! Tente novamente...');
    }
  }
}

export default function* watchUploadOfx() {
  yield takeLatest(UPLOAD_EXTRATOS_OFX, sagaUploadExtratoOfx);
}
